import { operatorClient } from 'domain/HttpClients';

export const fetch = (itineraryId) => operatorClient.Get(`/api/fleetowner/itineraries/${itineraryId}`).send();

export const complete = (itineraryId, payload) => operatorClient
  .Post(`/api/fleetowner/itineraries/${itineraryId}/complete`)
  .withData(payload)
  .send();

export const getRunSheet = (itineraries, drivers) => operatorClient
  .Get('/api/shipments/runsheet')
  .withParams({
    itineraries: itineraries.join(','),
  })
  .send();
